import React from 'react';

// Store
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';

// Routing
import { useHistory } from 'react-router';
import { APP_ROUTES } from 'src/routing/AppRoutes';

// UI
import { NotificationItem } from './NotificationItem';
import { NotificationsCard } from '../components/NotificationCard';
import { BaseDivider } from 'src/components/common';

// Utils
import { checkIsLoading } from 'src/utils/types/statuses';

// user identifications
import { USER_ROLES } from 'src/utils/types/user';

export const NotificationsSection: React.FC = () => {
  const upcomingInterviewsState = useSelector(
    (state: RootState) => state.upcomingInterviews,
  );

  const history = useHistory();
  const { user } = useSelector((state: RootState) => state.auth);

  const viewAll = () =>{
    if (user) {
      if (user.role === USER_ROLES.JOURNALIST) {
        history.push(APP_ROUTES.JOURNALIST_PLANNED_INTERVIEWS)
      }else if(user.role === USER_ROLES.EXPERT){
        history.push(APP_ROUTES.EXPERT_PLANNED_INTERVIEWS)
      }
    }
  }

  return (
    <NotificationsCard
      list={upcomingInterviewsState.data}
      bottomInfo={
        <>
          <BaseDivider mTop="8px" mBottom="8px" />
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <div
            style={{ textAlign: 'center', cursor: 'pointer' }}
            onClick={()=>viewAll()}>
            View all
          </div>
        </>
      }
      loading={checkIsLoading(upcomingInterviewsState.status)}
      renderedItem={(item) => (
        <NotificationItem interview={item} key={item.id} />
      )}
    />
  );
};
